import http from "./index";

export default {

  login(e) {  //登录
    return http.post("auth/login", e, false);
  },

};
